function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "screen-rotation-button",
  transform: "translate(-1.275)"
}, React.createElement("g", {
  id: "screen-rotation"
}, React.createElement("path", {
  id: "Path_67579",
  "data-name": "Path 67579",
  d: "M419.475,63.75c84.15,38.25,142.8,119.85,153,216.75h38.25C595.425,122.4,465.375,0,304.725,0h-17.85l96.9,96.9Zm-160.65-20.4c-15.3-15.3-38.25-15.3-53.55,0l-163.2,163.2c-15.3,15.3-15.3,38.25,0,53.55l306,306c15.3,15.3,38.25,15.3,53.551,0l163.2-163.2c15.3-15.3,15.3-38.25,0-53.551Zm117.3,497.25-306-306,163.2-163.2,306,306Zm-186.15,7.65c-84.15-38.25-142.8-119.85-153-216.75H1.275C14.025,489.6,144.075,612,304.725,612h17.85l-96.9-96.9Z",
  fill: "#fff"
})));
var SvgScreenRotationButton = function SvgScreenRotationButton(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    viewBox: "0 0 609.45 612",
    ref: svgRef
  }, props), _ref2);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgScreenRotationButton, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/screen-rotation-button.5a0c9890.svg";
export { ForwardRef as ReactComponent };